import { useState } from "react";
import { Link } from "react-router-dom";

const Field = ({ label, value, onChange, step, testid }) => (
  <label className="block">
    <span className="text-[10px] font-mono uppercase tracking-widest text-slate-500">{label}</span>
    <input type="number" step={step} min="0" value={value} data-testid={testid}
      onChange={(e) => onChange(parseFloat(e.target.value) || 0)}
      className="mt-1 w-full bg-black/40 border border-white/10 rounded-lg px-3 py-2 font-mono text-sm text-white focus:border-cyan-300/60 focus:outline-none" />
  </label>
);

export const ReconWidget = ({ recon, slug }) => {
  const [mg, setMg] = useState(recon.vial_mg || 10);
  const [ml, setMl] = useState(recon.default_water_ml || 2);
  const [dose, setDose] = useState(recon.default_dose_mcg || 250);
  const conc = ml > 0 ? (mg * 1000) / ml : 0;
  const vol = conc > 0 ? dose / conc : 0;
  const units = vol * 100;
  const doses = dose > 0 ? Math.floor((mg * 1000) / dose) : 0;

  return (
    <div data-testid="recon-widget" className="rounded-2xl border border-cyan-300/20 bg-gradient-to-br from-cyan-300/[0.06] to-transparent p-5 sm:p-6">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-4">
        <div>
          <div className="mono-label">Interactive Reconstitution</div>
          <div className="text-xs text-slate-400 mt-1">Adjust vial size, diluent and target dose. Results update live.</div>
        </div>
        <Link to={`/tools/calculator/${slug}`} className="text-xs font-mono text-cyan-300 hover:text-cyan-200">Full Precision Calculator →</Link>
      </div>
      <div className="grid grid-cols-3 gap-3">
        <Field label="Vial (mg)" value={mg} onChange={setMg} step="1" testid="recon-vial-mg" />
        <Field label="Water (mL)" value={ml} onChange={setMl} step="0.1" testid="recon-water-ml" />
        <Field label="Dose (mcg)" value={dose} onChange={setDose} step="10" testid="recon-dose-mcg" />
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mt-4">
        {[["Concentration", `${(conc / 1000).toFixed(2)} mg/mL`], ["Draw Volume", `${vol.toFixed(3)} mL`],
          ["Syringe Units", `${units.toFixed(1)} U`], ["Doses / Vial", `${doses}`]].map(([k, v]) => (
          <div key={k} className="bg-black/40 rounded-xl p-3 text-center">
            <div className="text-[10px] font-mono uppercase tracking-widest text-slate-500">{k}</div>
            <div data-testid={`recon-out-${k.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="font-mono text-base text-cyan-300 mt-1">{v}</div>
          </div>
        ))}
      </div>
      <p className="mt-3 text-[11px] font-mono text-slate-500">Units assume a U-100 insulin syringe (100 units = 1 mL). {recon.note}</p>
    </div>
  );
};
